import React, { Component } from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import DeviceCard from '../elements/DeviceCard';
import Button from '../elements/Button';
import SendButton from '../elements/SendButton';
import Heading from '../elements/PageHeading';
import Paragraph from '../elements/Paragraph';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin: auto;
  color: ${props => props.theme.secondary};
`;

const Notice = styled.div`
  margin: 0.5em auto 1em;
  padding: 0.6em 1em;
  max-width: 420px;
  text-align: center;
  background: ${props => props.theme.positiveTint || '#e6f4ea'};
  border-radius: 4px;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 10px auto 0px;
  align-items: center;
`;

const LaneForm = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px auto 0px;
  min-width: 280px;

  label {
    margin-top: 10px;
    margin-bottom: 4px;
  }

  select,
  input {
    padding: 6px;
    font-size: 1em;
  }
`;

/**
 * scale2 calibrate mode: one lane at a time, with a known weight on it. Lanes are addressed by shelf and
 * slot position (as shown on the cabinet screen), never by lane id. The cabinet screen shows the
 * progress and the result; this page starts the mode, sends one calibrate per lane and ends the mode.
 * The operator types the shelf and slot as shown on the cabinet screen.
 */
class Scale2CalibratePage extends Component {
  state = { shelf: '', slot: '', weight: '' };

  canCalibrate() {
    const shelf = Number(this.state.shelf);
    const slot = Number(this.state.slot);
    const weight = Number(this.state.weight);
    return (
      this.state.shelf !== '' &&
      this.state.slot !== '' &&
      Number.isInteger(shelf) &&
      Number.isInteger(slot) &&
      slot >= 0 &&
      Number.isFinite(weight) &&
      weight > 0
    );
  }

  render() {
    const {
      t,
      target,
      cancel,
      startCalibrate,
      calibrateLane,
      endCalibrate,
      message,
    } = this.props;
    const { shelf, slot, weight } = this.state;

    return (
      <Wrapper>
        <Heading text={t('management.scale2_calibrate')} />
        <DeviceCard device={target || {}} />
        <Paragraph>{t('management.scale2_calibrate_instruction')}</Paragraph>
        <Paragraph>{t('management.scale2_screen_note')}</Paragraph>
        {message && <Notice>{t(message)}</Notice>}
        <Buttons>
          <Button onClick={cancel}>{t('button.cancel')}</Button>
          &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
          <SendButton
            chevron={false}
            feedback
            onClick={() => startCalibrate()}
            text={t('button.startCalibrate')}
          />
          &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
          <SendButton
            chevron={false}
            feedback
            onClick={() => endCalibrate()}
            text={t('button.finishCalibrate')}
          />
        </Buttons>
        <LaneForm>
          <Paragraph>{t('management.scale2_position_hint')}</Paragraph>
          <label htmlFor="scale2-shelf">{t('management.scale2_shelf')}</label>
          <input
            id="scale2-shelf"
            type="number"
            min="1"
            step="1"
            value={shelf}
            onChange={event => this.setState({ shelf: event.target.value })}
          />
          <label htmlFor="scale2-slot">{t('management.scale2_slot')}</label>
          <input
            id="scale2-slot"
            type="number"
            min="0"
            step="1"
            value={slot}
            onChange={event => this.setState({ slot: event.target.value })}
          />
          <label htmlFor="scale2-weight">
            {t('management.scale2_weight_grams')}
          </label>
          <input
            id="scale2-weight"
            type="number"
            min="1"
            step="1"
            value={weight}
            onChange={event => this.setState({ weight: event.target.value })}
          />
          <Buttons>
            <SendButton
              chevron={false}
              feedback
              onClick={() =>
                this.canCalibrate() &&
                calibrateLane(Number(shelf), Number(slot), Number(weight))
              }
              text={t('button.calibrateLane')}
            />
          </Buttons>
        </LaneForm>
      </Wrapper>
    );
  }
}

export default translate()(Scale2CalibratePage);
